module.exports = __webpack_public_path__ + "img/9788983923615.b169b617.jpg";